import React, { useEffect, useRef, useState } from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, EmptyItem, StringLengthRule, RequiredRule, EmailRule, AsyncRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux'
import Box, { Item } from 'devextreme-react/box';
import { dialogProduct } from '../../store/product/productDialogReducer';
import { dialogCatalog } from '../../store/catalog/catalogDialogReducer';
import { createCustomStore, createStoreLocal } from '../../utils/proxy';
import { editorOptionsNumberBox, editorOptionsSelect, editorOptionsSwitch, editorOptsTextBox } from '../../data/app';
import { Button } from 'devextreme-react/button';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { dialogConvertProduct } from '../../store/convertProduct/convertProductDialogReducer';

//import { useBarcode } from 'react-barcodes';

const NuevoConvertir = props => {

    let refProductA = useRef();
    let refProductB = useRef();

    const [saving, setSaving] = useState(false);
    const [ randomId, setRandomId ] = useState(0);
    const [product, setProduct] = useState({ productA: {}, productB: {}, convertProductId: 0, sourceQuantity: 0, targetQuantity: 0 });


    const dispatch = useDispatch();
    const { convertProductDialog: { open, sourceProductId, targetProductId } } = useSelector(store => store);

    const closeDialog = (load) => {

        dispatch(dialogConvertProduct({ open: false, sourceProductId: 0, targetProductId: 0 }));
        
        if (load) {

            let { onSave } = props;
            onSave();

        }
    }

    const onHiding = ({ load }) => {

        closeDialog(load);

    }

    const guardarProduct = (e) => {

        let result = confirm("<i>Esta seguro de convertir?</i>", "Confirmar");
        result.then((dialogResult) => {
            if (dialogResult){
                notify(`Función no implementada`, 'warning');
                // setSaving(true);
                // http(uri.products.insert).asPost({ ...product })
                // .then(resp => {
                //     setSaving(false);
                //     notify(`Conversión creada correctamente`);
                //     setRandomId(Math.random());
                // })
                // .catch(err => {
                //     setSaving(false);
                //     notify(err, 'error');
                // });
            }
        });
        // let resultValidate = refProduct.current.instance.validate();

        // resultValidate.complete.then(result => {
        //     if (result.isValid) {

        //         setSaving(true);

        //         http(uri.products.insert).asPost({ ...product })
        //             .then(resp => {
        //                 setSaving(false);
        //                 notify(`Producto creado correctamente`);
        //                 closeDialog(true);
        //             })
        //             .catch(err => {
        //                 setSaving(false);
        //                 notify(err, 'error');
        //             })
        //     }
        // });
    }

    useEffect(() => {

        if (sourceProductId > 0) {
            http(uri.productConvertions.base + `/get/source/${sourceProductId}/target/${targetProductId}`).asGet()
                .then(resp => {
                    console.log(resp);
                    setProduct({
                        productA: { ...resp.sourceProduct, sourceProductId: resp.sourceProductId, sourceQuantity: resp.sourceQuantity, sourceQuantityReq: 0 },
                        productB: { ...resp.targetProduct, targetProductId: resp.targetProductId, targetQuantity: resp.targetQuantity, targetQuantityReq: 0 },
                        convertProductId: resp.id,
                        sourceProductId: resp.sourceProductId,
                        targetProductId: resp.targetProductId,
                        sourceQuantity: resp.sourceQuantity,
                        targetQuantity: resp.targetQuantity
                    });
                })
        }

    }, [sourceProductId, targetProductId, randomId]);

    const loadStocks = async () => {
        if (sourceProductId > 0) {
            const resp = await http(uri.productConvertions.base + `/get-stock/${sourceProductId}`).asGet();
            setProduct(prev => ({ ...prev, productA: { ...prev.productA, stock: resp.stock } }));
        }
        if (targetProductId > 0) {
            const resp = await http(uri.productConvertions.base + `/get-stock/${targetProductId}`).asGet();
            setProduct(prev => ({ ...prev, productB: { ...prev.productB, stock: resp.stock } }));
        }
    }

    useEffect(() => {
        loadStocks();
    }, [sourceProductId, targetProductId]);


    const handleValueChange = (e) => {

        const newValue = e.value;

        const { targetQuantity } = product.productB;

        const newTargetQuantityReq = newValue * targetQuantity;
        const productB = { ...product.productB, 'targetQuantityReq': newTargetQuantityReq };
        setProduct(prev => ({ ...prev, productB }));

    }

    return (
        <div>
            <Popup
                width={'90vw'}
                height={'300px'}
                title={`Crear Conversión de Producto`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <div>
                    <Form formData={product.productA} ref={refProductA} colCount={21} labelLocation='top' showValidationSummary={true}>
                        <SimpleItem dataField="internalCode" colSpan={2} editorType="dxTextBox" editorOptions={{ readOnly: true }} >
                            <Label text="Código" />
                        </SimpleItem>
                        <SimpleItem dataField="name" colSpan={7} editorType="dxTextBox">
                            <Label text="Nombre" />
                        </SimpleItem>
                        <SimpleItem dataField="unitOfMeasure.name" colSpan={3} editorType="dxTextBox">
                            <Label text="Unidad de Medida" />
                        </SimpleItem>
                        <SimpleItem dataField="family.name" colSpan={3} editorType="dxTextBox">
                            <Label text="Categoría" />
                        </SimpleItem>
                        <SimpleItem dataField="stock" colSpan={2} editorType="dxNumberBox" editorOptions={{ readOnly: true }} >
                            <Label text="Stock" />
                        </SimpleItem>
                        <SimpleItem dataField="sourceQuantity" colSpan={2} editorType="dxNumberBox" editorOptions={{ readOnly: true }} >
                            <Label text="Relacion" />
                        </SimpleItem>
                        <SimpleItem dataField="sourceQuantityReq" colSpan={2} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox, onValueChanged: (e) => handleValueChange(e, 'sourceQuantityReq') }} >
                            <Label text="Cantidad Requerida" />
                        </SimpleItem>
                    </Form>
                    <Form formData={product.productB} ref={refProductB} colCount={21} labelLocation='top'>
                        <SimpleItem dataField="internalCode" colSpan={2} editorType="dxTextBox" editorOptions={{ readOnly: true }} >
                            <Label text="Código" />
                        </SimpleItem>
                        <SimpleItem dataField="name" colSpan={7} editorType="dxTextBox">
                            <Label text="Nombre" />
                        </SimpleItem>
                        <SimpleItem dataField="unitOfMeasure.name" colSpan={3} editorType="dxTextBox">
                            <Label text="Unidad de Medida" />
                        </SimpleItem>
                        <SimpleItem dataField="family.name" colSpan={3} editorType="dxTextBox">
                            <Label text="Categoría" />
                        </SimpleItem>
                        <SimpleItem dataField="stock" colSpan={2} editorType="dxNumberBox" editorOptions={{ readOnly: true }} >
                            <Label text="Stock" />
                        </SimpleItem>
                        <SimpleItem dataField="targetQuantity" colSpan={2} editorType="dxNumberBox" editorOptions={{ readOnly: true }} >
                            <Label text="Relacion" />
                        </SimpleItem>
                        <SimpleItem dataField="targetQuantityReq" colSpan={2} editorType="dxNumberBox" editorOptions={{ readOnly: true }} >
                            <Label text="Cantidad Requerida" />
                        </SimpleItem>
                    </Form>
                </div>

                <div>
                    <Button
                        width={120}
                        text={`${saving ? 'Convirtiendo...' : 'Convertir'}`}
                        type="default"
                        icon="save"
                        stylingMode="contained"
                        className="m-1"
                        disabled={saving}
                        onClick={guardarProduct}
                    />
                </div>
            </Popup>
        </div>
    );
}

export default NuevoConvertir;
